// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import BankStatementsController from "./bank_statements_controller"
import AdminMetricsController from "./admin_metrics_controller"
import DropdownController from "./dropdown_controller"
import TurnstileController from "./turnstile_controller"

application.register("hello", HelloController)
application.register("bank-statements", BankStatementsController)
application.register("admin-metrics", AdminMetricsController)
application.register("dropdown", DropdownController)
application.register("turnstile", TurnstileController)
